import { render } from "./creategroup_page.vue?vue&type=template&id=4deac62f&scoped=true"
import script from "./creategroup_page.vue?vue&type=script&lang=js"
export * from "./creategroup_page.vue?vue&type=script&lang=js"

import "./creategroup_page.vue?vue&type=style&index=0&id=4deac62f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4deac62f"]])

export default __exports__